var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burger-closed-wrap",on:{"click":function($event){return _vm.openSidebar(!_vm.sidebarOpen)}}},[_c('Icon',{attrs:{"type":"menu","color":_vm.isColoredHeader ? 'oncolor' : 'primary',"size":"20"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }